import type { EnquiryModel } from "../features/enquiry/interfaceEnquiry";
import { enquiryListPath } from "./tmsRouteUtils";

export type EnquirySearchItem = {
    kind: "enquiry";
    id: string;
    label: string;
    subtitle: string;
    url: string;
    icon: string;
    enquiryId: number;
};

function enquiryHaystack(row: EnquiryModel): string {
    return [row.id, row.fullName, row.mobileNo, row.emailId, row.packageCode]
        .filter((x) => x !== undefined && x !== null)
        .map((x) => String(x).toLowerCase())
        .join(" ");
}

export function filterEnquirySearchItems(
    enquiries: EnquiryModel[],
    query: string,
    limit = 6
): EnquirySearchItem[] {
    const q = query.trim().toLowerCase();
    if (!q) return [];

    return enquiries
        .filter((row) => enquiryHaystack(row).includes(q))
        .slice(0, limit)
        .map((row) => ({
            kind: "enquiry" as const,
            id: `enquiry-${row.id}`,
            label: `Query #${row.id} — ${row.fullName || "Unknown"}`,
            subtitle: [row.mobileNo, row.emailId, row.statusName].filter(Boolean).join(" · "),
            url: `${enquiryListPath()}?q=${encodeURIComponent(String(row.id ?? ""))}`,
            icon: "ti-search",
            enquiryId: Number(row.id),
        }));
}
